<template>
  <md-card class="pb-10">
    <md-card-header class="md-card-header-text md-card-header-green">
      <div class="card-text mb-10">
        <h4 class="title text-lg">{{ $t("student.attendance") }}</h4>
      </div>
    </md-card-header>
    <md-card-content class="pt-0" v-if="termList.length">
      <div class="">
        <div class="flex justify-between">
          <div class="md-layout-item md-size-60 md-layout mt-3 font-medium">
            <div
              class="md-layout-item md-size-33 md-small-size-50 md-medium-size-50 md-xsmall-size-100 text-[#964AA0]"
            >
              {{ $t("attendance_report.student.excused_absence") }} - EA
            </div>
            <div
              class="md-layout-item md-size-33 md-small-size-50 md-medium-size-50 md-xsmall-size-100 text-[#D6030C]"
            >
              {{ $t("attendance_report.student.unexcused_absence") }} - UA
            </div>
            <div
              class="md-layout-item md-size-33 md-small-size-50 md-medium-size-50 md-xsmall-size-100 text-[#08980E]"
            >
              {{ $t("attendance_report.student.present") }} - P
            </div>
            <div
              class="md-layout-item md-size-33 md-small-size-50 md-medium-size-50 md-xsmall-size-100 text-[#2D82B5]"
            >
              {{ $t("attendance_report.student.excused_tardy") }} - ET
            </div>
            <div
              class="md-layout-item md-size-33 md-small-size-50 md-medium-size-50 md-xsmall-size-100 text-[#D3660A]"
            >
              {{ $t("attendance_report.student.unexcused_tardy") }} - UT
            </div>
          </div>
          <div class="flex items-end">
            <md-button class="md-warning margin-btn-export" @click="exportFile">
              {{ $t("student.export_file") }}
            </md-button>
          </div>
        </div>
        <div class="p-1 min-w-[300px] overflow-x-auto">
          <div v-for="(termData, index) in termList" :key="index + 'term'">
            <single-term class="mr-5" :term-data="termData"></single-term>
          </div>
        </div>
      </div>
    </md-card-content>
    <no-data-found v-else></no-data-found>
  </md-card>
</template>
<script>
import SingleTerm from "./SingleTerm";
import { service_names, service_paths } from "@/constants/Services";
import { Message } from "@/helpers/utils";

export default {
  components: { SingleTerm },
  props: ["studentData", "isActiveTab"],
  data() {
    return {
      termList: [],
      isActive: false
    };
  },
  watch: {
    isActiveTab: function(newVal) {
      if (this.isActive) return;
      if (newVal) {
        this.initData();
        this.isActive = true;
      }
    }
  },
  computed: {
    studentId() {
      return this.$route.params.id;
    }
  },
  methods: {
    initData() {
      const studentId = this.$route.params.id;
      this.$axios
        .get(`${service_names.school}/attendances/user/${studentId}`)
        .then(response => {
          this.termList = response.data;
        });
    },
    async exportFile() {
      let termData = this.termList.map(item => {
        item.percent_instructional = `${item.instructional_pass_days} / ${item.instructional_days}`;
        return item;
      });
      let grade = await this.$axios
        .get(`${service_paths.students}/${this.studentId}`)
        .then(res => res.data.grade);
      let body = {
        student_code: this.studentData?.student_code,
        attendances: termData,
        grade: grade
      };
      this.$axios
        .post(
          `${service_paths.export}/attendances/pdf`,
          body,
          undefined,
          undefined,
          "blob"
        )
        .then(response => {
          if (response.status === 200) {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "student-attendance.pdf");
            document.body.appendChild(link);
            Message.success(this.$t("common.export_success"));
            link.click();
            link.remove();
          } else {
            Message.error(this.$t("common.an_error_occurred"));
          }
        });
    }
  }
};
</script>
<style lang="scss" scoped>
@media screen and (min-width: 900px) {
  .margin-btn-export {
    margin-right: 26px;
  }
}
</style>
